export default {
  API_GET_REQUEST: "API_GET_REQUEST",
  API_GET_RECIEVE: "API_GET_RECIEVE",
  API_GET_ERROR: "API_GET_ERROR"
};
